export const Moves: {[k: string]: ModdedMoveData} = {
	aurawheel: {
		inherit: true,
		isNonstandard: "Past",
	},
	bloodmoon: {
		inherit: true,
		isNonstandard: "Future",
	},
	clangingscales: {
		inherit: true,
		isNonstandard: "Past",
	},
	clangoroussoul: {
		inherit: true,
		isNonstandard: "Past",
	},
	darkvoid: {
		inherit: true,
		isNonstandard: "Past",
	},
	doomdesire: {
		inherit: true,
		isNonstandard: "Past",
	},
	forestscurse: {
		inherit: true,
		isNonstandard: "Past",
	},
	grassyglide: {
		inherit: true,
		basePower: 60,
	},
	ivycudgel: {
		inherit: true,
		isNonstandard: "Future",
	},
	jetpunch: {
		inherit: true,
		hasSheerForce: true,
	},
	matchagotcha: {
		inherit: true,
		isNonstandard: "Future",
	},
	seedflare: {
		inherit: true,
		isNonstandard: "Past",
	},
	strangesteam: {
		inherit: true,
		isNonstandard: "Past",
	},
	syrupbomb: {
		inherit: true,
		isNonstandard: "Future",
	},
	tailglow: {
		inherit: true,
		isNonstandard: "Past",
	},
	takeheart: {
		inherit: true,
		isNonstandard: "Past",
	},
	toxicthread: {
		inherit: true,
		isNonstandard: "Past",
	},
};
